import { render, staticRenderFns } from "./DrawingsCatalogItem.vue?vue&type=template&id=47552c92"
import script from "./DrawingsCatalogItem.vue?vue&type=script&lang=js"
export * from "./DrawingsCatalogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports